module.exports = __webpack_public_path__ + "img/green-carpet-grass-09.853a2331.png";